import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13b52c7f&scoped=true&v=2"
import script from "./index.vue?vue&type=script&lang=js&v=2"
export * from "./index.vue?vue&type=script&lang=js&v=2"
import style0 from "./index.vue?vue&type=style&index=0&id=13b52c7f&prod&scoped=true&lang=scss&v=2"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b52c7f",
  null
  
)

export default component.exports